import { render } from "./top-bar.vue?vue&type=template&id=fc90afa6&ts=true"
import script from "./top-bar.vue?vue&type=script&lang=ts"
export * from "./top-bar.vue?vue&type=script&lang=ts"

import "./top-bar.vue?vue&type=style&index=0&id=fc90afa6&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__